import sliceCreator from '../../index.js';
import {GET_ALL_ADMINS} from '../../../constants/index.js';
const _getAllAdminsAction = sliceCreator('GET_ALL_ADMINS', GET_ALL_ADMINS, 'get');

const { asyncAction: getAllAdminsAction, reducer, clearData: clearGetAllAdminsAction } = _getAllAdminsAction;

export default reducer;

export {
    getAllAdminsAction,
    clearGetAllAdminsAction
}